import React from 'react';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-primary-950 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-300">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center hover:text-primary-300 transition-colors">
                <Mail className="h-5 w-5 mr-2" />
                cerclepoincare.001@gmail.com
              </li>
              <li className="flex items-center hover:text-primary-300 transition-colors">
                <Phone className="h-5 w-5 mr-2" />
                06 14 15 45 90
              </li>
              <li className="flex items-center hover:text-primary-300 transition-colors">
                <MapPin className="h-5 w-5 mr-2" />
                2 rue des 4 églises, 54000 Nancy
              </li>
            </ul>
            <div className="mt-6">
              <img
                src="https://i.imgur.com/XxYajsA.jpeg"
                alt="Cercle Poincaré"
                className="h-24 w-auto object-contain bg-white rounded-lg p-2"
              />
            </div>
          </div>
          <div className="relative h-64 md:h-full min-h-[300px] rounded-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2634.4080124457244!2d6.181752776882611!3d48.69080831501882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4794986e17a692cd%3A0x4ed671b10d82498d!2s2%20Rue%20des%20Quatre%20%C3%89glises%2C%2054000%20Nancy!5e0!3m2!1sfr!2sfr!4v1709913424037!5m2!1sfr!2sfr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="absolute inset-0"
            />
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4">
            <p>&copy; {new Date().getFullYear()} Cercle Poincaré. Tous droits réservés.</p>
            <Link to="/mentions-legales" className="hover:text-primary-300 transition-colors">
              Mentions légales & CGU
            </Link>
          </div>
          <div className="text-sm">
            <a
              href="https://www.linkedin.com/in/jibril-talbi/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gray-400 hover:text-primary-300 transition-colors group"
            >
              Site créé par TALB-E
              <Linkedin className="h-4 w-4 group-hover:text-primary-300 transition-colors" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};